import { Branding, DisabledPrompt } from "bcms-react";
import { MainNavItem, MainNavMenuItem } from "components/shared/views/MainNavView";
// import "./styles.css";

/**
 * @name BID1225BMainNavItems
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 1225 Business.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID2132BMainNavItems/>
 *      </div>
 *  );
 * }
 */
export default function BID1225BMainNavItems(props) {


  const newAccountsLink = <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountSummary", "/statements", "/stopPayment", "/download"]}>
    <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
    <MainNavMenuItem label="Statements & Notices" route="/statements" data-point="Nav_eStatements_Notices" />
    <MainNavMenuItem label="Stop Payments" route="/stopPayment" data-point="Nav_Stop_Payments" />
    <MainNavMenuItem className="web-connect" label="WebConnect" route="/download" data-point="Nav_Download" />
    <DisabledPrompt>
      <MainNavMenuItem label="Fraud Prevention" data-point="Nav_Fraud_Prevention" />
    </DisabledPrompt>
  </MainNavItem>;

  const newTransfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={["/transfers", "/externalTransfers", "/transferActivity/scheduledTransfers", "/unlinkedTransferAccounts"]} >
    <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer" />
    <MainNavMenuItem label="External Transfers" route="/externalTransfers" data-point="Nav_External_Transfers" />
    <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity" />
    <MainNavMenuItem label="Intrabank Accounts" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts" />
  </MainNavItem>;

  const paymentLink = <DisabledPrompt><MainNavItem label="Payments" data-point="Nav_Payments" /></DisabledPrompt>;

  const cardsLink = <DisabledPrompt><MainNavItem label="Cards" data-point="Nav_Cards" /></DisabledPrompt>;

  const zleMainNavItem = <MainNavItem label={<>Zelle<span className="r-mark">&reg;</span></>} route="/zelle" data-point="Nav_Zelle" />;

  const achLinks = <MainNavItem label="ACH" data-point="Nav_ACH" activeRoutes={["/achParticipants", "/achTemplates", "/achActivity", "/achPassthru", "/achImport", "/stateTaxIDPage", "/denyUsers", "/oneTimeACHWorkflow"]} >
    <MainNavMenuItem label="ACH Participants" route="/achParticipants" data-point="Nav_ACH_Participants" />
    <MainNavMenuItem className="one-time-ach-payment-main-nav-item" label="One-Time ACH Payment" route="/oneTimeACHWorkflow" data-point="Nav_One-Time_ACH_Payments" />
    <MainNavMenuItem label="ACH Templates" route="/achTemplates" data-point="Nav_ACH_Templates" />
    <MainNavMenuItem label="ACH Activity" route="/achActivity" data-point="Nav_ACH_Activity" />
    <DisabledPrompt>
      <MainNavMenuItem label="NACHA Import" data-point="Nav_NACHA_Import" />
    </DisabledPrompt>
    <MainNavMenuItem label="Import File" data-point="Nav_Import">
      <MainNavMenuItem label="Participant Import" data-point="Nav_Participant_Import" route="/achImport" />
      <DisabledPrompt>
        <MainNavMenuItem label="Non-NACHA Import" data-point="Nav_Non_NACHA_Import" />
      </DisabledPrompt>
    </MainNavMenuItem>
    <MainNavMenuItem label="State Tax IDs" route="/stateTaxIDPage" data-point="Nav_State_Tax_IDs" />
    <MainNavMenuItem label="Deny Users" route="/denyUsers" data-point="Nav_Deny_Users" />
  </MainNavItem>;

  const wiresLink = <MainNavItem label="Wires" data-point="Nav_Wires">
    <DisabledPrompt>
      <MainNavMenuItem label="Wire Payees" data-point="Nav_Wire_Payees" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Single Wire" data-point="Nav_Single_Wire" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Wire Activity" data-point="Nav_Wire_Activity" />
    </DisabledPrompt>
  </MainNavItem>

  // END: Branded links declared here and returned in the component.

  return (
    <Branding id="bid_abi22" value="1225B">
      <div className="flex-container flex-horizontal bid-1225B-menu">
        {newAccountsLink}
        {newTransfersLink}
        {paymentLink}
        {cardsLink}
        {zleMainNavItem}
        {achLinks}
        {wiresLink}
      </div>
    </Branding>
  );
}
